import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { Flame, Shield, Stethoscope, Pill, CreditCard, Landmark, Wrench, Phone } from "lucide-react";

const EMERGENCY = [
  { icon: Flame, label: "Feuerwehr & Rettungsdienst", number: "112", tel: "tel:112" },
  { icon: Shield, label: "Polizei", number: "110", tel: "tel:110" },
  { icon: Stethoscope, label: "Ärztlicher Bereitschaftsdienst", number: "116 117", tel: "tel:116117" },
];

const FURTHER = [
  { icon: Pill, label: "Apotheken-Notdienst", number: "0800 00 22 833", tel: "tel:080000228 33".replace(/ /g, "") },
  { icon: CreditCard, label: "Sperr-Notruf EC-/Kreditkarten", number: "116 116", tel: "tel:116116" },
  { icon: Landmark, label: "KVA Immobilienmanagement · Herr Wittig", number: "030 2581 85 226", tel: "tel:+4930258185226" },
  { icon: Wrench, label: "Hausmeister KVA · Herr Gerson", number: "0176 633 49 196", tel: "tel:+4917663349196" },
];

export default function Rufnummern() {
  return (
    <section id="rufnummern" className="py-16 md:py-28 bg-[#EFECE4] border-y border-[#D8D3C5]" data-testid="rufnummern-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          number="07"
          eyebrow="Wichtige Rufnummern"
          title="Schnelle Hilfe im Ernstfall"
          text="Die wichtigsten Nummern für die Anlage und den Notfall – direkt antippbar."
        />

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {EMERGENCY.map((e, i) => (
            <Reveal key={e.label} delay={i * 0.08}>
              <a
                href={e.tel}
                data-testid={`emergency-call-${i}`}
                className="group flex h-full flex-col justify-between rounded-2xl border border-[#B93829]/25 bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[#B93829]"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#B93829]/10 text-[#B93829]">
                    <e.icon size={21} strokeWidth={1.8} />
                  </span>
                  <Phone size={16} className="text-[#6F7E73] transition-colors group-hover:text-[#B93829]" />
                </div>
                <div className="mt-6">
                  <p className="font-display text-4xl font-bold tracking-tight text-[#1A382B]">{e.number}</p>
                  <p className="mt-1 text-sm font-medium text-[#47544A]">{e.label}</p>
                </div>
              </a>
            </Reveal>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {FURTHER.map((e, i) => (
            <Reveal key={e.label} delay={0.15 + i * 0.06}>
              <a
                href={e.tel}
                data-testid={`number-call-${i}`}
                className="group flex items-center gap-4 rounded-2xl border border-[#D8D3C5] bg-white px-6 py-5 transition-all duration-300 hover:-translate-y-0.5 hover:border-[#5A826B]"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#E2ECE5] text-[#1A382B]">
                  <e.icon size={19} strokeWidth={1.8} />
                </span>
                <div className="min-w-0">
                  <p className="truncate text-sm font-medium text-[#47544A]">{e.label}</p>
                  <p className="font-jbm text-base font-semibold text-[#1A382B]">{e.number}</p>
                </div>
                <Phone size={16} className="ml-auto shrink-0 text-[#6F7E73] transition-colors group-hover:text-[#C85A32]" />
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
